// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '504ccc5c8985fb30e5395a453f32c2b3a06ccb3e';
export const BUILD_NUMBER = '250';
export const BUILD_TIMESTAMP = '2026-09-24T06:13:15.916Z';
